<template>
  <div class="back-btn" @click="back()">
    <img src="../../assets/back/icon_comeback.png" alt="">
  </div>
</template>

<script>
export default {
  name: "Back",
  methods: {
    back() {
      this.$emit('change', 'back')
    }
  }
}
</script>

<style scoped>
.back-btn img {
  position: fixed;
  z-index: 2;
  bottom: 70px;
  left: 50%;
  width: 98px;
  height: 98px;
  margin-left: -370px;
}
</style>
